import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useGetStep } from 'shared/hooks'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useProgressInfoTitle } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/hooks/useProgressInfoTitle'
import {
  BuyNumberStepsProvider,
  useBuyNumberStepsContext,
} from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/context/useBuyNumberStepsContext'
import { type BuyNumberRoutesSteps } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/store/buyNumberStore'

const BuyNumberLayoutContent = observer(() => {
  const { allStepsLength, decreaseStep, setCurrentStep, getSettingsStep, redirectToNumbers } =
    useBuyNumberStepsContext()
  const settingsStep = useGetStep<BuyNumberRoutesSteps>(getSettingsStep)
  const infoTitle = useProgressInfoTitle()

  useEffect(() => {
    setCurrentStep(settingsStep)
  }, [settingsStep, setCurrentStep])

  return (
    <StepsCommonLayout
      progressTitle={infoTitle}
      totalSteps={allStepsLength}
      title='Buy number'
      settingsStep={settingsStep}
      closeSetting={redirectToNumbers}
      decreaseStep={decreaseStep}
    />
  )
})

export const BuyNumberStepsLayout = () => {
  return (
    <BuyNumberStepsProvider>
      <BuyNumberLayoutContent />
    </BuyNumberStepsProvider>
  )
}
